import React from "react";

const Photo = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-photo"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-photo"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="m8,22.5c0,.828-.672,1.5-1.5,1.5h-1c-3.032,0-5.5-2.468-5.5-5.5v-1c0-.828.672-1.5,1.5-1.5s1.5.672,1.5,1.5v1c0,1.379,1.121,2.5,2.5,2.5h1c.828,0,1.5.672,1.5,1.5Zm14.5-6.5c-.828,0-1.5.672-1.5,1.5v1c0,1.379-1.121,2.5-2.5,2.5h-1c-.828,0-1.5.672-1.5,1.5s.672,1.5,1.5,1.5h1c3.032,0,5.5-2.468,5.5-5.5v-1c0-.828-.672-1.5-1.5-1.5ZM18.5,0h-1c-.828,0-1.5.672-1.5,1.5s.672,1.5,1.5,1.5h1c1.379,0,2.5,1.121,2.5,2.5v1c0,.828.672,1.5,1.5,1.5s1.5-.672,1.5-1.5v-1c0-3.032-2.468-5.5-5.5-5.5ZM1.5,8c.828,0,1.5-.672,1.5-1.5v-1c0-1.379,1.121-2.5,2.5-2.5h1c.828,0,1.5-.672,1.5-1.5s-.672-1.5-1.5-1.5h-1C2.468,0,0,2.468,0,5.5v1c0,.828.672,1.5,1.5,1.5Zm10.5,2c-1.105,0-2,.895-2,2s.895,2,2,2,2-.895,2-2-.895-2-2-2Zm3.5,8h-7c-1.93,0-3.5-1.57-3.5-3.5v-5c0-1.93,1.57-3.5,3.5-3.5h.196l.885-1.331c.278-.418.747-.669,1.249-.669h2.34c.502,0,.971.251,1.249.669l.885,1.331h.196c1.93,0,3.5,1.57,3.5,3.5v5c0,1.93-1.57,3.5-3.5,3.5Zm.5-8.5c0-.275-.225-.5-.5-.5h-7c-.275,0-.5.225-.5.5v5c0,.275.225.5.5.5h7c.275,0,.5-.225.5-.5v-5Z" />
    </svg>
  );
};

export default Photo;
